import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle-qipyf",
  "use": "check-circle-qipyf-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-circle-qipyf\"><path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\" /><path d=\"M22 4L12 14.01l-3-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol